/**
 * Translate a slug
 * @param state Redux state
 * @param slug Localization slug to translate
 */
export function translate(state, slug) {
    return _.get(state, `core.localizations.containers.chromeLocalization.${slug}`, `{${slug}}`);
}

/**
 * Take a string with placeholders (%1, %2, etc.) and replace each placeholder
 * with the corresponding value in a list of parameters.
 * @param  {String}  text   String to operate upon
 * @param  {Array}   params List of values to be used for each text placeholder
 * @return {Boolean}        The original string with interpolated values
 */
export function interpolate(text, params) {
    return params.reduce(
        (val, param, idx) => val.replace(`%${idx + 1}`, param), text);
}
